import Vue from 'vue';

export default {
    parse: function(componentId, componentType, { store, router }) {
        document.querySelectorAll(`[data-component-type="${componentId}"]`).forEach((node) => {
            const propsAttribute = node.getAttribute('data-component-props') || '';
            const propsAttributeString = `{ ${propsAttribute} }`;
            const propsData = JSON.parse(propsAttributeString);
            // instantiate new Vue component with props, store, and router if provided
            // set component on node
            const ComponentClass = Vue.extend(componentType);
            const componentInstance = new ComponentClass({ store, propsData, router });
            componentInstance.$mount(); // pass nothing
            try {
                node.parentNode.replaceChild(componentInstance.$el, node); // insert into DOM
            } catch (error) {
                // not all nodes allow this (ie. unit testing)
                // the component is still usable, just not visible in the document,
                // which is ok for unit testing
            }
        });
    }
};
